// extracted by mini-css-extract-plugin
export default {"wrapper":"parent-warning-popup_wrapper__GmVOS","popup":"parent-warning-popup_popup__w9vxF"};